export default "https://assets.pclncdn.com/web/next-landing/b33de4d/_next/static/images/Two-43f2bfbd4854c2d779530dca660b1708.svg";